<style scoped>
  .header {
    margin-bottom: 16px;
  }
  .bill {
    margin-bottom: 15px;
  }
</style>
<template>
  <div>
    <v-card
      outlined
      class="header"
    >
      <v-card-title>
        <v-row>
          <v-col
            cols="12"
            md="4"
          >
            <v-select
              v-model="params.company_id"
              :items="companies"
              item-text="short_name"
              item-value="id"
              label="公司"
              clearable
              hide-details
              @change="query"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <VTeamSelector
              v-model="params.team_id"
              label="团队"
              :placeholder="null"
              clearable
              hide-details
              @change="query"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              v-model="params.search"
              append-icon="mdi-magnify"
              label="搜索"
              single-line
              hide-details
              clearable
              :loading="loading"
              @click:append="search"
              @click:clear="searchClear"
              @keydown.enter="search"
            />
          </v-col>
        </v-row>
      </v-card-title>
    </v-card>

    <VListContainer
      item-value="id"
      :items="bills"
      :loading="loading"
      skeleton="article@3"
    >
      <template v-slot="{ item }">
        <PaymentAccrualBillCard
          class="bill"
          :data="item"
          @edit="editExpenseGroup"
        />
      </template>
    </VListContainer>

    <div class="paginate-fix-bottom">
      <VPage
        :current="page_info.current"
        :total="page_info.total"
        :page-size="page_info.page_size"
        @pageChange="pageChange"
      />
    </div>

    <ExpenseGroupEditor
      ref="editor"
      @update="query"
    />
  </div>
</template>
<script route="/fin_bill/fin_payment_accrual_bill">
  import BillQueryBase from './mixins/bill_query_base';
  import {mapGetters} from "vuex";
  import PaymentAccrualBillCard from './components/payment_accrual_bill_card';
  import ExpenseGroupEditor from '../expense_group/components/editor';

  export default {
    components: { PaymentAccrualBillCard, ExpenseGroupEditor },
    mixins: [ BillQueryBase ],
    data() {
      return {
        bill_query_path: 'fin_payment_accrual_bill/query',
      }
    },
    computed: {
      ...mapGetters('async', ['companies'])
    },
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      editExpenseGroup(bill) {
        this.$refs.editor.edit({id: bill.expense_group_id});
      }
    }
  }
</script>
